// src/features/policies/modals/PolicyVersionsModal.jsx

import React, { useEffect, useState } from "react";

import PolicyVersionTable from "../components/PolicyVersionTable";

import { getPolicyVersions } from "../api/policyApi";

export default function PolicyVersionsModal({
  policyId,
  apiKey,
  tenantId,
  onClose
}) {

  const [versions, setVersions] = useState([]);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  useEffect(() => {

    async function loadVersions() {

      setLoading(true);

      setError("");

      try {

        const response =
          await getPolicyVersions(
            apiKey,
            tenantId,
            policyId,
            0,
            50
          );

        setVersions(
          response.content || []
        );

      } catch (e) {

        setError(
          e.message
        );

      } finally {

        setLoading(false);

      }

    }

    loadVersions();

  }, [
    apiKey,
    tenantId,
    policyId
  ]);

  return (

    <div className="modal-overlay">

      <div className="modal-content modal-lg">

        <div className="modal-title">
          Policy Versions
        </div>

        <div className="modal-subtitle">
          Available versions for this policy
        </div>

        {
          error && (

            <div className="policy-error">
              {error}
            </div>

          )
        }

        {
          loading
            ? (
                <div className="policy-empty">
                  Loading versions...
                </div>
              )
            : (
                <PolicyVersionTable
                  versions={versions}
                />
              )
        }

        <div className="modal-actions">

          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>

        </div>

      </div>

    </div>

  );

}